import React, { useMemo } from 'react';
import { DataJson, WorldClass } from '../data/types';
import { ColorCell } from './colCell';

interface Props {
    data: DataJson;
}

export const ColorViewer: React.FC<Props> = ({ data }) => {
    const worlds = useMemo(() =>
        data.worlds
            .filter(x => x.class !== WorldClass.Sovereign)
            .sort((a, b) => (a.tier - b.tier) || a.name.localeCompare(b.name))
        , [data])
    const colors = useMemo(() => new Map(data.colors.map(e => [e.id, e])), [data]);

    console.log(colors);

    return <>
        <table>
            <thead>
                <tr>
                    <th className="worldTier" rowSpan={2}>T</th>
                    <th className="worldName" rowSpan={2}>World</th>
                    <th rowSpan={2}>Type</th>
                    <th rowSpan={2}>Region</th>
                    <th colSpan={3} className="colSep groupHeader">Rock</th>
                    <th colSpan={3} className="colSep groupHeader">Wood</th>
                </tr>
                <tr>
                    <th className="colSep">Sedimentary</th>
                    <th>Metamorphic</th>
                    <th>Igneous</th>

                    <th className="colSep">Twisted</th>
                    <th>Lustrous</th>
                    <th>Ancient</th>
                </tr>
            </thead>
            <tbody>
                {worlds.map(world => <tr key={world.id}>
                    <td className="worldTier">{world.tier + 1}{world.class === WorldClass.Exoworld ? 'X' : ''}</td>
                    <td className="worldName">{world.name}</td>
                    <td>{world.type}</td>
                    <td>{world.region}</td>

                    <ColorCell blocks={world.colors} colors={colors} type="10802" className="colSep" />
                    <ColorCell blocks={world.colors} colors={colors} type="10794" />
                    <ColorCell blocks={world.colors} colors={colors} type="10798" />

                    <ColorCell blocks={world.colors} colors={colors} type="10834" className="colSep" />
                    <ColorCell blocks={world.colors} colors={colors} type="10838" />
                    <ColorCell blocks={world.colors} colors={colors} type="10830" />
                </tr>)}
            </tbody>
        </table>
    </>
}